
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/auth/[...type]",
      function () {
        return require("private-next-pages/[lang]/auth/[...type].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/auth/[...type]"])
      });
    }
  